import { memo } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";

function Whychooseus() {
  const path = window.location.pathname;

  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 whyimg">
              <img
                src="../photo/whychoose.jpg"
                style={{ objectFit: "contain" }}
                alt=""
              />
            </div>
            <div className="col-lg-6 whychoose">
              <div>
                <h1>Why Choose Us</h1>
                <p>
                  Welcome to our Orthopedic Services! We are dedicated to
                  providing exceptional care for all your orthopedic needs. Our
                  hospital specializes in the diagnosis, treatment, and
                  rehabilitation of musculoskeletal conditions, helping you
                  regain mobility and improve your quality of life.
                </p>

                <p>
                  Our team focuses on personalized treatment plans for
                  conditions affecting bones, joints, muscles, ligaments, and
                  tendons. From minor injuries to complex orthopedic problems,
                  we combine clinical expertise with modern techniques to
                  support safe recovery and long-term joint health.
                </p>

                <p>
                  Whether you are dealing with fractures, joint pain, sports
                  injuries, spine concerns, or age-related joint conditions, our
                  goal is to help you move comfortably and return to your daily
                  activities with confidence.
                </p>

                <div className="imgcont addwhy">
                  <div className="imgconbox">
                    <img src="../photo/google-maps.png" alt="" />
                  </div>
                  <div className="context">
                    <h6>
                      95,15th Main, 17th Cross Rd, 5th Phase, J. P. Nagar,
                      Bengaluru, Karnataka 560078
                    </h6>
                  </div>
                </div>
                {path === "/contact" && (
                  <div className="imgcont addwhy">
                    <div className="imgconbox">
                      <img src="../photo/google-maps.png" alt="" />
                    </div>
                    <div className="context">
                      <h6>
                        <a
                          href="https://maps.app.goo.gl/eskKVaMxXNXvsApB8"
                          style={{ color: "white", textDecoration: "none" }}
                        >
                          ATREUM SPECIALITY HOSPITAL RR Nagar | Orthopedician |
                          Gastroenterologist | Urologist | Neurologist |
                          Physician
                        </a>
                      </h6>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default memo(Whychooseus);
